import { Button, Modal, Row, Col } from "react-bootstrap";

export function ModalHandleDeclinado({open, setOpen, handleDeclinarAppointment, handleCloseDeclinar}){

    return (
        <Modal show={open} onHide={handleCloseDeclinar} backdrop="static" keyboard={false} size="lg">
            <Modal.Body className="position-relative overflow-hidden">
                <h5 className="text-center mb-5">¿Usted está seguro desea rechazar su consentimiento informado?  Al seleccionar 
                Si, no se podrá continuar con su atención médica?</h5>                    
                <Row className="text-center">
                    <Col>
                        <Button 
                            variant="secondary" 
                            onClick={() => {
                                setOpen(false)
                            }}
                        >No
                        </Button>{' '}
                        <Button 
                            variant="success" 
                            onClick={handleDeclinarAppointment}
                        >Si
                        </Button>
                    </Col>
                </Row> 
            </Modal.Body>
        </Modal>
    )
}